import React, { useContext } from "react";
import { AppContext } from "../context/app.context";

/**
 * Time Machine #114 Phase 4 — header button that toggles the inline picker
 * panel. When time-travel is already active, clicking this button exits
 * back to live (the banner has its own Return-to-Live affordance, but
 * having the same button toggle keeps the header behavior predictable).
 *
 * Visibility:
 *   - hidden when whichList is "logs" or "userList" (those screens don't
 *     have a time-travelable concept; Time Machine watches Attributes,
 *     ActiveQueue, Candidates, Offices — not Logs or Users)
 *   - hidden when not logged in (no AppContext mongoUser-equivalent here;
 *     the parent Header only renders this child when mongoUser exists)
 *
 * Visual: matches the existing "?" help icon's circular outline style
 * with a clock emoji centered. When isTimeTraveling, fills with the
 * yellow accent to surface the active state.
 */
const TimeMachineButton = ({ onClick }) => {
  const { isTimeTraveling, exitTimeTravel, whichList } = useContext(AppContext);

  if (whichList === "logs" || whichList === "userList") {
    return null;
  }

  const handleClick = () => {
    if (isTimeTraveling) {
      exitTimeTravel();
    } else if (typeof onClick === "function") {
      onClick();
    }
  };

  const baseClasses =
    "w-7 h-7 ml-4 rounded-full border-2 font-bold leading-none flex items-center justify-center hover:opacity-75";
  const stateClasses = isTimeTraveling
    ? "border-yellow bg-yellow text-black"
    : "border-skin-link text-skin-link";

  return (
    <button
      onClick={handleClick}
      type="button"
      title={isTimeTraveling ? "Return to live" : "Time travel"}
      aria-label={isTimeTraveling ? "Return to live" : "Time travel"}
      aria-pressed={isTimeTraveling}
      data-tutorial-target="time-machine-button"
      className={`${baseClasses} ${stateClasses}`}
    >
      <span aria-hidden="true">{"\u{1F552}"}</span>
    </button>
  );
};

export default TimeMachineButton;
